import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { H1, H7 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import Small from 'UIComponents/elements/Small';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { CALYPSO, GYPSUM, THUNDERDOME } from 'HubStyleTokens/colors'; // @ts-expect-error svgs are untyped modules

import blobsImageUrl from 'bender-url!ecosystem-marketplace-solutions-base/img/explainer-blob.svg';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
const BACKGROUND_COLOR = GYPSUM;
const BADGE_HEIGHT = '20px';
const StyledExplainerWrapper = styled(UIFlex).withConfig({
  displayName: "StorefrontExplainer__StyledExplainerWrapper",
  componentId: "sc-1jfzbd6-0"
})(["flex-direction:row;background-color:", ";background-image:url(", ");background-position:center center;background-repeat:no-repeat;background-size:auto 150%;padding:40px 75px;"], BACKGROUND_COLOR, blobsImageUrl);
const StyledStepNumberBadge = styled.div.withConfig({
  displayName: "StorefrontExplainer__StyledStepNumberBadge",
  componentId: "sc-1jfzbd6-1"
})(["display:inline-block;flex-shrink:0;background-color:", ";color:white;mix-blend-mode:multiply;height:", ";width:", ";line-height:", ";text-align:center;border-radius:50%;font-weight:500;margin-right:12px;"], THUNDERDOME, BADGE_HEIGHT, BADGE_HEIGHT, BADGE_HEIGHT);
const StyledStepWrapper = styled(UIGridItem).withConfig({
  displayName: "StorefrontExplainer__StyledStepWrapper",
  componentId: "sc-1jfzbd6-2"
})(["display:flex;margin-top:12px;"]);
const StyledCopyWrapper = styled.div.withConfig({
  displayName: "StorefrontExplainer__StyledCopyWrapper",
  componentId: "sc-1jfzbd6-3"
})(["max-width:250px;"]);

const StorefrontExplainer = () => {
  const {
    illustrationClassName,
    showIllustration
  } = useResponsiveProps({
    illustrationClassName: {
      lg: 'm-left-15',
      xs: "m-top-4 m-left-6"
    },
    showIllustration: {
      lg: true,
      md: false,
      xs: true
    }
  });
  return /*#__PURE__*/_jsx(StyledExplainerWrapper, {
    children: /*#__PURE__*/_jsx(MainSectionInner, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        style: {
          flexGrow: 0
        },
        direction: "column",
        children: [/*#__PURE__*/_jsx(H1, {
          style: {
            paddingBottom: '8px',
            borderBottom: `2px solid ${CALYPSO}`
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.homepage.explainer.title"
          })
        }), /*#__PURE__*/_jsxs(UIGrid, {
          children: [/*#__PURE__*/_jsxs(StyledStepWrapper, {
            size: {
              xs: 12,
              md: 4,
              lg: 3
            },
            children: [/*#__PURE__*/_jsx(StyledStepNumberBadge, {
              children: "1"
            }), /*#__PURE__*/_jsxs(StyledCopyWrapper, {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepOne.title"
                })
              }), /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepOne.description"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(StyledStepWrapper, {
            size: {
              xs: 12,
              md: 4,
              lg: 3
            },
            children: [/*#__PURE__*/_jsx(StyledStepNumberBadge, {
              children: "2"
            }), /*#__PURE__*/_jsxs(StyledCopyWrapper, {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepTwo.title"
                })
              }), /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepTwo.description"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(StyledStepWrapper, {
            size: {
              xs: 12,
              md: 4,
              lg: 3
            },
            children: [/*#__PURE__*/_jsx(StyledStepNumberBadge, {
              children: "3"
            }), /*#__PURE__*/_jsxs(StyledCopyWrapper, {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepThree.title"
                })
              }), /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.explainer.stepThree.description"
                })
              })]
            })]
          }), showIllustration && /*#__PURE__*/_jsx(UIGridItem, {
            size: {
              xs: 12,
              lg: 3
            },
            children: /*#__PURE__*/_jsx(UIIllustration, {
              className: illustrationClassName,
              width: "150px",
              name: "approvals"
            })
          })]
        })]
      })
    })
  });
};

export default StorefrontExplainer;